import { languageService } from "../../../../Language/language.service";
import { arrayToSelectOptions } from "../../../../utils/arrayToSelectOptions";
import { isFraRole } from "../../../MainPage/UserInfo";

const dateFormat = "MM-DD-yy";


const FRADateLimit = new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString()

export const hosSearchFiltersFormSchema = {
  title: languageService("Search HOS Records"),
  id: "hosSearchFiltersFormSchema",
  returnOnlyEnabledFields: false,
  stateTitle: {
    draft: `${languageService("Search HOS Records")}*`,
    stable: languageService("Search HOS Records"),
  },
  sections: [
    {
      id: "typeSelectionSection",
      fields: [
        {
          id: "employeeEmail", // required
          type: "select", // required
          labelValue: languageService("Employee"),
          required: true,
          selectOptions: [],
          col: 4,
        },
        {
          id: "activityTypeCode", // required
          type: "select", // required
          labelValue: languageService("Activity Note"),
          selectOptions: [],
          col: 4,
        },
      ],
    },
    {
      id: "dateAndTimeEntrySection",
      fields: [
        {
          id: "startDate",
          type: "date",
          labelValue: languageService("Start Date"),
          format: dateFormat,
          ...(isFraRole() && { minDate: FRADateLimit }),
          ...(!isFraRole() && { pastOnly: true }),
          col: 4,
        },
        {
          id: "endDate",
          type: "date",
          labelValue: languageService("End Date"),
          format: dateFormat,
          ...(isFraRole() && { minDate: FRADateLimit }),
          ...(!isFraRole() && { pastOnly: true }),
          col: 4,
        },
      ],
    },
    {
      id: "comlianceSelectionSection",
      fields: [
        {
          id: "viewNonCompliantRecords", // required
          type: "checkbox", // required
          labelValue: languageService("View non-compliant records"),
          showFieldsOnCertainValue: [{ values: [true], targetIds: ["violations"] }],
          col: 12,
        },
        {
          id: "violations", // required
          type: "multiSelect", // required
          labelValue: languageService("Violations"),
          selectOptions: [],
          col: 4,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "searchRecords",
          type: "button",
          labelValue: languageService("Search"),
          action: "submit",
          callback: "searchRecords",
          position: "footer",
          col: 12,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosReport/schemas/hosSearchFiltersFormSchema.js